import {
  AccountTransactionDirection,
  ListTaxWithholdingTransactionsFilterParameterStatusEq as TaxWithholdingTransactionStatus,
  TaxWithholdingTransaction,
  TaxWithholdingTransactionType
} from "@wingspanhq/wingspan-api-sdk";

const formatTaxPaymentTitle = (
  prefix: string,
  transaction: TaxWithholdingTransaction
): string =>
  transaction.quarter && transaction.year
    ? `${prefix} - ${transaction.quarter} ${transaction.year}`
    : prefix;

export const selectorTaxWithholdingTransactionTitle = (
  transaction: TaxWithholdingTransaction
): string => {
  if (transaction.type === TaxWithholdingTransactionType.TAX_PAYMENT) {
    return formatTaxPaymentTitle(
      transaction.status === TaxWithholdingTransactionStatus.SCHEDULED
        ? "Scheduled payment to IRS"
        : "Payment to IRS",
      transaction
    );
  }

  if (transaction.invoiceNumber) {
    return `Set aside from Invoice #${transaction.invoiceNumber}`;
  }

  return transaction.direction === AccountTransactionDirection.CREDIT
    ? "Deposit"
    : "Withdraw";
};
